// Контракт видео плейлиста с экспериментами — один модуль для обеих сторон
// (PlaylistCard.vue и tzPlatformLinks), как в save-from.
//
// Payload события tzBestQuality — массив качеств лучше отданных с полем duration
// (getBetterQualities). У видео плейлиста к нему добавляются:
//   kind: PLAYLIST_PAYLOAD_KIND — признак плейлиста;
//   list: HTMLElement — .link-box блока этого видео (ItemResultDefault.vue).
// Без kind payload — одиночное видео (ResultDefault.vue): эксперимент ищет
// первый .result-box .link-box на странице, а в плейлисте блоков много.

export const PLAYLIST_PAYLOAD_KIND = 'playlist';

export function playlistPayload(qualities, list) {
  qualities.kind = PLAYLIST_PAYLOAD_KIND;
  qualities.list = list;
  return qualities;
}

export function isPlaylistPayload(data) {
  return Boolean(data && data.kind === PLAYLIST_PAYLOAD_KIND && data.list);
}
